import React from 'react';
import SEOLandingPage from '../SEOLandingPage';
import { Video, Layers, Sparkles, Smartphone } from 'lucide-react';

const PhysicsVideoGeneratorPage: React.FC = () => {
  return (
    <SEOLandingPage 
      title="Physics Video Generator"
      description="Automatically generate viral physics videos for social media. Our physics animation maker helps you create satisfying ball simulations and ASMR loops in seconds."
      keywords="physics video generator, physics animation maker, satisfying video creator, physics shorts generator, automated physics videos, fun circle games, funcirclegames, fun circle games creator studio"
      heroTitle="Viral Physics Video Generator"
      heroSubtitle="Transform complex physics simulations into stunning 4K videos. The #1 tool for generating high-retention content for YouTube Shorts and TikTok."
      videoMeta={{
        name: "Viral Physics Video Generator Demo",
        description: "See how our generator transforms raw physics data into high-retention social media content.",
        thumbnailUrl: "https://funcirclegames.com/thumbnails/physics-gen-hero.jpg",
        uploadDate: "2026-05-19T12:00:00Z",
        contentUrl: "https://funcirclegames.com/videos/physics-gen-demo.mp4",
        embedUrl: "https://funcirclegames.com/embed/physics-gen-demo"
      }}
      features={[
        {
          title: "One-Click Export",
          description: "Instantly export your simulations as high-quality video files ready for social upload.",
          icon: <Video className="w-6 h-6" />
        },
        {
          title: "Template Library",
          description: "Choose from dozens of pre-configured physics environments to speed up your workflow.",
          icon: <Layers className="w-6 h-6" />
        },
        {
          title: "Auto-Styling",
          description: "Apply professional color palettes and visual filters with a single click for a polished look.",
          icon: <Sparkles className="w-6 h-6" />
        },
        {
          title: "Mobile Optimized",
          description: "Videos are rendered in portrait mode, perfectly framed for TikTok, Reels, and Shorts.",
          icon: <Smartphone className="w-6 h-6" />
        }
      ]}
      contentSnippet="Creating engaging physics videos used to require expensive software and hours of rendering. Our online physics video generator democratizes high-quality animation, allowing anyone to build satisfying ball simulations that capture attention and drive engagement. Perfect for faceless channels looking to scale content production without sacrificing quality."
      currentTool="/physics-video-generator"
    />
  );
};

export default PhysicsVideoGeneratorPage;
